import { render } from "./pacchetti.vue?vue&type=template&id=720aeb24&bindings={\"navRoute\":\"options\",\"onMainChange\":\"options\",\"onThumbClicked\":\"options\"}"
import script from "./pacchetti.vue?vue&type=script&lang=js"
export * from "./pacchetti.vue?vue&type=script&lang=js"

import "./pacchetti.vue?vue&type=style&index=0&lang=postcss"
script.render = render
/* custom blocks */
import block0 from "./pacchetti.vue?vue&type=custom&index=0&blockType=route"
if (typeof block0 === 'function') block0(script)


export default script